import { getAction, postAction } from '@/utils/request'

/**
 * 聊天信息 表格 之发送邮件
 * @param response_id 聊天返回的id
 *
 * 返回模型：
 * {
 *   “isSent”:true,
 *   "message":"发送成功"
 * }
 *
 * 当isSent=false时，message里面是服务器返回的错误信息
 */
export function sendEmailApi(response_id) {
  return postAction('/api/v1/notifications/email', { id: response_id }, undefined)
}

/**
 * 发送问题给服务器(用户输入的问题)
 * @param message
 * 返回参数模型 见大模型定义 ChatResponse.ts里面
 * @return {Promise<ResponseGroupMessage>}
 */
export function sendChatApi(message) {
  return postAction('/api/v1/chat/chat', { message: message }, undefined)
}

/**
 * 获取欢迎语
 *  返回参数模型 见大模型定义 ChatResponse.ts里面
 * @return {Promise<ResponseGroupMessage>}
 */
export function getWelcomeApi() {
  return postAction('/api/v1/chat/welcome', {}, undefined)
}

/**
 * 获取faq 点击FAQ 的气泡时调用
 *  返回参数模型 见大模型定义 ChatResponse.ts里面
 * @return {Promise<ResponseGroupMessage>}
 */
export function getFaqApi() {
  return getAction('/api/v1/faq/faq', undefined, undefined)
}

/**
 * 获取经销商库存 点击经销商库存 的气泡时调用
 *  返回参数模型 见大模型定义 ChatResponse.ts里面
 * @return {Promise<ResponseGroupMessage>}
 */
export function getInventoryApi() {
  return getAction('/api/v1/faq/inventory', undefined, undefined)
}

/**
 * 记录错误日志
 * @param id {string} response最外层的id responseGroupId
 * @param responseId {string} item里面的responseId
 * @param renderCategory  {"UNKNOWN_CATEGORY" | "MARKDOWN" | "TABLE" | "ECHARTS" | "MIXED"} item里面的renderCategory
 * @param errorMessage {string} 错误信息,比如说 无法解析option;columnHeaders为空等等
 */
export function sendErrorLog(id, responseId, renderCategory, errorMessage) {
  return postAction('/api/v1/chat/errorlog', {
    id: id,
    response_id: responseId,
    render_category: renderCategory,
    error_message: errorMessage,
  })
}
